import explore_image from '@/public/features/explore.webp';
// import schedule_3 from '@/public/features/sales/Streamline-Payment-Processes-with-Ease.webp';
import app_1 from '@/public/features/gps_tracking/App_1.webp';
import app_2 from '@/public/features/review_managment/App_2.webp';
import schedule_2 from '@/public/features/review_managment/Comments.webp';
import schedule_5 from '@/public/features/review_managment/Enhance Customer Communication_2.webp';
import bg from '@/public/features/review_managment/Frame 1171278053.webp';
import schedule_1 from '@/public/features/review_managment/Schedule.webp';
import schedule_4 from '@/public/features/review_managment/Schedule_2.webp';
import { CalendarIcon, CardIcon, ToolsIcon, WalletIcon } from '@/public/icons';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const intro = {
  tag: 'Review Management Software',
  description: `Boost your reputation effortlessly with our free review management software. Our reputation management app, designed specifically for home services, makes it easier than ever to manage and respond to customer reviews. Improve your business’s credibility today.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Top Free Review Management',
  second_title: 'Software for Home Services',
};

const faq = {
  title: 'FAQ',
  items: [
    {
      title: `How Does Online Review Management Software Work?`,
      text: `Online review management software helps businesses monitor, collect, and respond to customer reviews across multiple platforms. It automates review requests, filters negative feedback for private resolution, and integrates with social media to enhance your online presence and credibility.`,
    },
    {
      title: `How Can Review Management Software Help a Home Service Business?`,
      text: `Reputation management software boosts home service review management by improving its online reputation, increasing customer feedback, and attracting more clients. It simplifies the review process, providing valuable insights and allowing businesses to address issues promptly and enhance customer satisfaction.`,
    },
    {
      title: `What Are the Benefits of Using Review Management Software?`,
      text: `Reputation management software makes the process easier when collecting and managing customer feedback related to your business. It enhances your online reputation for the betterment of your company, which increases client satisfaction and provides important insights into the improvement of services to draw more clients.`,
    },
    {
      title: `How Does Customer Reviews Management Software Improve Online Presence?`,
      text: `Customer review management software links your business social media pages, and satisfied clients are forwarded to drop positive reviews online. This way, visibility builds up, trust is gained, and more prospective clients are drawn toward your home service business.`,
    },
  ],
};

const testimonals = {
  title: 'Client’s Testimonials',
  description: '',
  items: [
    {
      text: `Negative review protection has saved our reputation countless times. We can address issues privately and make necessary improvements without damaging our public image. Highly recommend Orcatec for any business serious about maintaining a positive reputation`,
      name: 'Mike L.',
      position: 'FixItPro',
    },
    {
      text: `Linking our profiles has raised our visibility for even more clients. Customers can easily leave positive reviews, which helps us build trust and credibility online. It’s a fantastic feature that integrates seamlessly with our workflow.`,
      name: 'Emma R.',
      position: 'HomeComfort Solutions',
    },
    {
      text: `With Orcatec, managing reviews is so simple. Our brand trust has significantly increased, and we’re seeing more repeat business. The detailed reporting and automated responses make the whole process smooth and efficient.`,
      name: 'David P.',
      position: 'PureClean Services',
    },

    {
      text: `Negative review protection has saved our reputation countless times. We can address issues privately and make necessary improvements without damaging our public image. Highly recommend Orcatec for any business serious about maintaining a positive reputation`,
      name: 'Mike L.',
      position: 'FixItPro',
    },
    {
      text: `Linking our profiles has raised our visibility for even more clients. Customers can easily leave positive reviews, which helps us build trust and credibility online. It’s a fantastic feature that integrates seamlessly with our workflow.`,
      name: 'Emma R.',
      position: 'HomeComfort Solutions',
    },
    {
      text: `With Orcatec, managing reviews is so simple. Our brand trust has significantly increased, and we’re seeing more repeat business. The detailed reporting and automated responses make the whole process smooth and efficient.`,
      name: 'David P.',
      position: 'PureClean Services',
    },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Get the latest tips for dealing with your customer reviews and getting a better online reputation. Stay in the loop with expert advice, industry trends, and best practices for your home service business to thrive in the digital age.`,
};

const bookDemo = {
  title: `Get more benefits when you start\xa0your\xa0business\xa0with\xa0Orcatec`,
  description: `Participate in the transformative power of Orcatec’s review management software for any business. Enhance your online standing, draw more customers, and simplify your client feedback process effortlessly. Fill in the form below to get started for free.`,
};

const articles = {
  title: `How Does Review Management\xa0Software\xa0Work?`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_1,
        alt: 'On-Site Proposal Creation',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'One-Click Review Request',
      text: `Easily send a review request to your clients immediately after completing a job with just one click. This ensures you capture fresh feedback when the service experience is still top of mind, leading to higher response rates and more accurate reviews.`,
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_2,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Negative Review Protection',
      text: `Negative reviews with a rating of 1-3 stars are visible only to you within the software, protecting your public reputation. This feature allows you to address issues privately, take corrective actions, and improve your service without harming your online image.`,
    },

    /*  {
      type: ArticleType.HORIZONTAL,
      image: {
        path: schedule_3,
        alt: 'Streamlined Approval Process',
      },
      list: [],
      href: '#',
      tag: '',
      title: `Customizable and Personalized\xa0Proposals`,
      text: `At the core of the software's functionality is its ability to produce highly customizable and personalized proposals. You can tailor every aspect of the proposal, from headers and layouts to itemized or total pricing, ensuring that each proposal reflects the unique value proposition you offer to the client.\n\nThis level of personalization helps to create a connection with the client and demonstrates a deep understanding of their needs.`,
    }, */
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_5,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Strengthening Your Brand',
      text: `The more positive reviews you gather, the more your brand will become trusted, thus attract more clients and acquire a market position. The more positive feedback there is toward you, the better your reputation will become, leading to higher business opportunities and loyalty toward you by the clients.`,
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_4,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Improving Online Presence',
      text: `By linking your social media profiles, you can direct clients to leave positive reviews on those platforms for 4 and 5-star reviews. This integration helps to enhance your online presence, driving more traffic to your social accounts and boosting your overall visibility.`,
    },
  ],
};

const fullArticle1 = {
  image: {
    path: app_1,
    alt: `Why Orcatec is Right For You?`,
  },
  title: `Why Orcatec is\xa0Right\xa0For\xa0You?`,
  description: `Online reputation management for business is one of the most significant things in today's digital world. Orcatec is one perfect stop for home service experts to handle the review process easily and create a reputation in the market. So, Orcatec is the right choice for you because of: `,
  item: [
    {
      title: 'Comprehensive Review Management',
      description:
        'Orcatec offers an all-in-one solution for managing your customer reviews efficiently. From sending review requests with a single click to protecting your reputation from negative feedback, our software covers all your needs.',
    },
    {
      title: 'Enhanced Online Presence',
      description:
        'By combining your social media profiles, Orcatec enables your immediately pleased clients to leave positive reviews on numerous media. This increases your online visibility and entices more potential customers',
    },
    {
      title: 'Strengthened Brand Trust',
      description: `With Orcatec, you can accumulate more positive reviews, enhancing your brand’s credibility. The more trust you make, the more clients you attract, leading to supported business development`,
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What Is Review Management Software?`,
  },
  title: `What Is Review Management\xa0Software?`,
  description: `The review management software for home services is built to allow businesses to monitor, analyze, and respond to customer-based reviews, or any form of feedback, from different online sources.\n\nThis is a tool that collects and streamlines all feedback from different platforms, thus maintaining an online reputation while offering customer engagement. The use of free reputation management software brings out the credibility of your businesses, ensuring traffic while also ensuring long-term loyalty from customers.`,
  item: [
    {
      title: '',
      description:
        'Reputation management software helps track testimonials from multiple platforms in one place.',
    },
    {
      title: '',
      description:
        'It provides sentiment analysis to understand customer feedback better.',
    },

    {
      title: '',
      description: `Automated replies and exhaustive reporting features save time and aid in data conclusions.`,
    },
  ],
};

const explore = {
  title: 'Explore More ',
  subtitle: 'Tools For Job Success',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
  for the latest trends and tips in service scheduling software free`,
  image: explore_image,
  items: [
    {
      title: 'Complete Job & Invoice',
      path: IRoutePath.FEATURES_INVOICING,
      icon: WalletIcon,
      items: [
        {
          title: 'Sales Proposal Tool',
          path: '',
        },

        {
          title: 'Invoicing',
          path: '',
        },
        {
          title: 'Estimates',
          path: '',
        },
        {
          title: 'Quoting',
          path: '',
        },
      ],
    },
    {
      title: 'Scheduling & Dispatching',
      path: IRoutePath.FEATURES_SCHEDULIG,
      icon: CalendarIcon,
      items: [
        {
          title: 'Employee GPS Tracking',
          path: '',
        },
        {
          title: 'Scheduling Software',
          path: '',
        },
        {
          title: 'Route Optimization',
          path: '',
        },
        {
          title: 'Field Service App',
          path: '',
        },
        {
          title: 'Voice Solutions',
          path: '',
        },
        {
          title: 'Dispatching',
          path: '',
        },
      ],
    },
    {
      title: 'Get Paid & Expenses',
      path: IRoutePath.FEATURES,
      icon: CardIcon,
      items: [
        {
          title: 'Commissions Management',
          path: '',
        },
        {
          title: 'Home Services Marketing',
          path: '',
        },
        {
          title: 'Automated Direct Mail',
          path: '',
        },
        {
          title: 'Consumer Financing',
          path: '',
        },
        {
          title: 'Advanced Reporting',
          path: '',
        },
        {
          title: 'Expenses Tracking',
          path: '',
        },

        {
          title: 'Contractor Payroll',
          path: '',
        },
        {
          title: 'Card Reader',
          path: '',
        },
      ],
    },
    {
      title: 'Job Management',
      icon: ToolsIcon,
      path: IRoutePath.FEATURES,
      items: [
        {
          title: 'Work Order Management',
          path: '',
        },
        {
          title: 'Field Service CRM',
          path: '',
        },
        {
          title: 'Job Management',
          path: '',
        },
        {
          title: 'Job Tracking',
          path: '',
        },
        {
          title: 'Job Costing',
          path: '',
        },
      ],
    },
  ],
};

export {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
  explore,
};
